export default __webpack_public_path__ + "static/media/P3 klubben_inspelningstekniker_mixare.572432a1.jpeg";